import { $getQueryParams } from '@/utils';
import httpService from '@Utils/httpService';

const baseUrl = 'api/links';

export default {
  get(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + '?' + qParams.toString(),
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  addOrUpdate(data, isNew) {
    if (isNew)
      return httpService.post({
        url: baseUrl,
        data,
      });
    else {
      return httpService.put({
        url: `${baseUrl}/${data.id}`,
        data,
      });
    }
  },
  

  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
};
